<ng-template #templateViewDL>
  <div class="modal-header">
    <h5 class="modal-title">Preview</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="this.modelDLPreview.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center pt-4">
    <img class="img-responsive profile-pic" [src]="dlImageUrl" style="max-width: 100%;max-height: 350px;" />
   </div>
  <div class="modal-footer">
    <button type="button" data-dismiss="modal" class="btn btn-outline-primary mr-3" style="display: none;" (click)="reScanDL()">
      <i class="fa fa-print mr-2"></i>ReScan</button>
    <div class="button_tooltip">
      <button type="button" data-dismiss="modal" class="btn btn-primary" (click)="fillform()">Proceed</button>
    </div>
  </div>
</ng-template>

<ng-template #templateDeviceConnected>
  <div class="modal-header">
    <h5 class="modal-title">Device</h5>
  </div>
  <div class="modal-body ptb24">
    <p class="mb-0">{{dlScannerMessage}}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="dlReaderInfoModel.hide()" i18n="@@Ok">OK</button>
  </div>
</ng-template>

<ng-template #templateScanError>
  <div class="modal-header">
    <h5 class="modal-title">Failed</h5>
  </div>
  <div class="modal-body ptb24">
    <p class="mb-0">Cannot read the document data. Please try again!</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="dlScanValidation.hide()" i18n="@@Ok">OK</button>
  </div>
</ng-template>